export enum OrdersActionTypes {
  GET_LIST_ORDERS_SUCCESS = "ORDERS_GET_LIST_SUCCESS",
  GET_LIST_ORDERS_ERROR = "ORDERS_GET_LIST_ERROR",
  GET_LIST_ORDERS = "ORDERS_GET_LIST",
  CREATE_ORDER = "CREATE_ORDER",
  CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS",
  CREATE_ORDER_ERROR = "CREATE_ORDER_ERROR",
  GET_ORDER = "GET_ORDER",
  GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS",
  GET_ORDER_ERROR = "GET_ORDER_ERROR",
  UPDATE_ORDER = "UPDATE_ORDER",
  UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS",
  UPDATE_ORDER_ERROR = "UPDATE_ORDER_ERROR",
  UPDATE_STATUS_ORDER = "UPDATE_STATUS_ORDER",
  UPDATE_STATUS_ORDER_SUCCESS = "UPDATE_STATUS_ORDER_SUCCESS",
  UPDATE_STATUS_ORDER_ERROR = "UPDATE_STATUS_ORDER_ERROR",
  DELETE_ORDER = "DELETE_ORDER",
  DELETE_ORDER_SUCCESS = "DELETE_ORDER_SUCCESS",
  DELETE_ORDER_ERROR = "DELETE_ORDER_ERROR",
  DOWNLOAD_SAMPLE = "DOWNLOAD_SAMPLE",
  DOWNLOAD_SAMPLE_SUCCESS = "DOWNLOAD_SAMPLE_SUCCESS",
  DOWNLOAD_SAMPLE_ERROR = "DOWNLOAD_SAMPLE_ERROR",
  UPLOAD_MULTIPLE_ORDERS = "UPLOAD_MULTIPLE_ORDERS",
  UPLOAD_MULTIPLE_ORDERS_SUCCESS = "UPLOAD_MULTIPLE_ORDERS_SUCCESS",
  UPLOAD_MULTIPLE_ORDERS_ERROR = "UPLOAD_MULTIPLE_ORDERS_ERROR",
  BULK_UPDATE_AGENT = "BULK_UPDATE_AGENT",
  BULK_UPDATE_AGENT_SUCCESS = "BULK_UPDATE_AGENT_SUCCESS",
  BULK_UPDATE_AGENT_ERROR = "BULK_UPDATE_AGENT_ERROR",
}
